import CompetitionsTable from "../components/competitions/CompetitionsTable";
import EmptyState from "../components/shared/EmptyState";
import ErrorState from "../components/shared/ErrorState";
import LoadingState from "../components/shared/LoadingState";
import { Container } from "@mui/material";
import { isCompetitionVisibleInResults } from "../utils/resultPublicationUtils";
import { useCompetitionsContext } from "../contexts/CompetitionsContext";

export default function CompetitionsList() {
  const { competitions, loading, error, refreshCompetitions } = useCompetitionsContext();
  const visibleCompetitions = competitions.filter((competition) => isCompetitionVisibleInResults(competition));

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <LoadingState message="Ładowanie turniejów..." />
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <ErrorState message={error} onRetry={refreshCompetitions} />
      </Container>
    );
  }

  if (visibleCompetitions.length === 0) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <EmptyState message="Nie znaleziono turniejów z wynikami" />
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      <CompetitionsTable competitions={visibleCompetitions} />
    </Container>
  );
}
